"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const GenericCollection_1 = __importDefault(require("./GenericCollection"));
const LodashExtensions_1 = require("../LodashExtensions");
class GenericObjectCollection extends GenericCollection_1.default {
    constructor(features, attributes, 
    // TODO needed ?
    shouldIndexByInternalId = false, shouldIndexByShortname = false) {
        super(features, attributes);
        this._shouldIndexByInternalId = false; // TODO: should be replaced by a simple list of attributes to index
        this._shouldIndexByShortname = false;
        this._shouldIndexByInternalId = shouldIndexByInternalId;
        this._shouldIndexByShortname = shouldIndexByShortname;
        this._indexByInternalId = new Map();
        this._indexByShortname = new Map();
        this.updateIndexes();
    }
    getFeatureId(feature) {
        return feature.attributes.id;
    }
    updateIndexes() {
        super.updateIndexes();
        if (this._shouldIndexByInternalId) {
            this.updateIndexByInternalId();
        }
        if (this._shouldIndexByShortname) {
            this.updateIndexByShortname();
        }
    }
    updateIndexesForFeature(feature, index) {
        super.updateIndexesForFeature(feature, index);
        const internalId = feature.attributes.internal_id;
        if (this._shouldIndexByInternalId && typeof internalId === 'string' && internalId !== '') {
            this._indexByInternalId.set(internalId, index);
        }
        const shortname = feature.attributes.shortname;
        if (this._shouldIndexByShortname && typeof shortname === 'string' && shortname !== '') {
            this._indexByShortname.set(shortname, index);
        }
    }
    updateIndexByInternalId() {
        this._indexByInternalId.clear();
        for (let i = 0, count = this.size(); i < count; i++) {
            const feature = this._features[i];
            const internalId = feature.attributes.internal_id;
            if (typeof internalId === 'string' && internalId !== '') {
                this._indexByInternalId.set(internalId, i);
            }
            else {
                console.error(`trying to index by internal_id but the feature does not have a valid internal_id string (feature id: ${feature.id})`);
            }
        }
    }
    updateIndexByShortname() {
        this._indexByShortname.clear();
        for (let i = 0, count = this.size(); i < count; i++) {
            const feature = this._features[i];
            const shortname = feature.attributes.shortname;
            if (typeof shortname === 'string' && shortname !== '') {
                this._indexByShortname.set(shortname, i);
            }
            else {
                console.error(`trying to index by shortname but the feature does not have a valid shortname string (feature id: ${feature.id})`);
            }
        }
    }
    getByInternalId(featureInternalId) {
        const featureIndex = this._indexByInternalId.get(featureInternalId);
        return featureIndex !== undefined && featureIndex >= 0 ? this._features[featureIndex] : undefined;
    }
    getByShortname(featureShortname) {
        const featureIndex = this._indexByShortname.get(featureShortname);
        return featureIndex !== undefined && featureIndex >= 0 ? this._features[featureIndex] : undefined;
    }
    getIndexByInternalId(featureInternalId) {
        if (!this._shouldIndexByInternalId) {
            console.error('index by internal id is not activated');
        }
        if ((0, LodashExtensions_1._isBlank)(featureInternalId)) {
            console.error('feature internal id is blank');
        }
        return this._indexByInternalId.get(featureInternalId);
    }
    getIndexByShortname(featureShortname) {
        if (!this._shouldIndexByShortname) {
            console.error('index by shortname is not activated');
        }
        if ((0, LodashExtensions_1._isBlank)(featureShortname)) {
            console.error('feature shortname is blank');
        }
        return this._indexByShortname.get(featureShortname);
    }
    getByAttribute(attribute, value) {
        // attribute can be a full attribute path: exmaple: data.foo.bar
        const features = [];
        for (let i = 0, count = this._features.length; i < count; i++) {
            if (this._features[i].get(attribute) === value) {
                features.push(this._features[i]);
            }
        }
        return features;
    }
    // TODO object is of the type of the generic object attributes. Can we type it correctly?
    // In fact features could be simple objects to, in that case, we just pass them through directly.
    forJson(parser) {
        const jsonArray = [];
        if (this._features) {
            for (let i = 0, count = this.size(); i < count; i++) {
                const feature = this._features[i];
                const attributes = feature.attributes;
                if (parser && typeof parser === 'function') {
                    jsonArray.push(parser(attributes));
                }
                else {
                    jsonArray.push(attributes);
                }
            }
        }
        return jsonArray;
    }
}
exports.default = GenericObjectCollection;
//# sourceMappingURL=GenericObjectCollection.js.map